module.exports = __webpack_public_path__ + "img/strawberry_image.9a062209.jpg";